import { useCallback, useRef } from 'react'

import type { SlidesProps } from '@space-shell/common/components/imageSlider/types'

export const useContentAnimation = (slides: SlidesProps[]) => {
  const refContent = useRef<HTMLElement[]>([])

  const slideUpContent = useCallback(
    (slideAdd: number, slideRemove: number) => {
      const hasButton = slides[slideAdd]?.buttons?.some((button) => Boolean(button?.label))
      const hasContent =
        Boolean(slides?.[slideAdd]?.switchText && slides?.[slideAdd]?.text) ||
        (slides?.[slideAdd]?.switchButton && hasButton)

      if (hasContent && (slides?.[slideAdd]?.imageUrlWeb || slides?.[slideAdd]?.videoUrlWeb)) {
        refContent.current?.[slideAdd]?.classList?.add('slideUpActive')
      }
      if (refContent.current?.[slideRemove] !== undefined) {
        refContent.current?.[slideRemove]?.classList?.remove('slideUpActive')
      }
    },
    [slides]
  )

  return { refContent, slideUpContent }
}
